import { getCachedCartTimeoutMinutes, getCartExpiresAt } from "./cartExpiry";

/**
 * Drop the stored cart on app boot if its hold has lapsed.
 *
 * Uses the same deadline the countdown renders, via getCartExpiresAt. It used to
 * filter each item on its own `expired` while the countdown ran off a separate
 * clock that restarted on every add -- so a cart with two items could be purged
 * on reload while the timer on screen still showed 40 minutes left.
 */
const deleteExpiredCart = () => {
    const cartData = localStorage.getItem("cart");

    if (!cartData) return;

    try {
        const carts = JSON.parse(cartData);

        if (!Array.isArray(carts) || carts.length === 0) {
            localStorage.removeItem("cart");
            return;
        }

        // Same timeout the countdown uses, so the two cannot disagree about
        // whether the cart is still alive.
        const expiresAt = getCartExpiresAt(
            carts,
            localStorage.getItem("lastAddedBookToCart"),
            getCachedCartTimeoutMinutes()
        );

        if (expiresAt !== null && expiresAt.getTime() <= Date.now()) {
            // The whole cart shares one deadline, so it lapses as a unit.
            localStorage.removeItem("cart");
        }
    } catch (e) {
        console.error("Failed to parse cart data:", e);
    }
};

export default deleteExpiredCart;
